import axios from "axios";
import { getVersion } from "./utils";

export const registryRequest = (options, _url, payload, callback) => {
  const version = getVersion(_url);

  const url = version
    ? _url.replace(`@${version}--`, "--") + "?version=" + version
    : _url;

  axios
    .get(url)
    .then((res) => {
      callback(null, {
        status: res.status,
        data: JSON.stringify(res.data)
      });
    })
    .catch((err) => {
      console.error(`OneFront/i18n: failed to load language file.\n${url}`);
      callback(err);
    });
};
